<!-- 业务管理 -->
<template>
    <div id="business" class="business">
        <el-menu
                :default-active="bsactiveIndex"
                mode="horizontal"
                text-color="#fff"
                background-color="#92C7FF"
                active-text-color="#fff"
        >
            <el-menu-item index="1" class="nav-lv2"><router-link :to="menu.客服监控" v-if="menu.客服监控">客服监控</router-link></el-menu-item>
            <el-menu-item index="2" class="nav-lv2"><router-link :to="menu.客户记录" v-if="menu.客户记录">客户记录</router-link></el-menu-item>
            <el-menu-item index="3" class="nav-lv2"><router-link :to="menu.询价管理" v-if="menu.询价管理">询价管理</router-link></el-menu-item>
            <el-menu-item index="4" class="nav-lv2"><router-link :to="menu.汽配快搜" v-if="menu.汽配快搜">汽配快搜</router-link></el-menu-item>
            <el-menu-item index="5" class="nav-lv2"><router-link :to="menu.数据统计" v-if="menu.数据统计">数据统计</router-link></el-menu-item>
            <el-menu-item index="6" class="nav-lv2"><router-link :to="menu.帮助文档" v-if="menu.帮助文档">帮助文档</router-link></el-menu-item>
            <el-menu-item index="7" class="nav-lv2"><router-link :to="menu.检修管理" v-if="menu.检修管理">检修管理</router-link></el-menu-item>
            <el-menu-item index="8" class="nav-lv2"><router-link :to="menu.商城管理" v-if="menu.商城管理">商城管理</router-link></el-menu-item>

               <!-- <el-menu-item :index="(1+index)" class="nav-lv2" v-for="(item,index) in menu" :key="index">
                            <router-link :to="item.Url">{{item.Name}}</router-link>
                        </el-menu-item> -->
        </el-menu>
        <router-view/>
    </div>
</template>
<script>
    export default {
        name: 'business',
        components: {},
        data() {
            return {
                bsactiveIndex:this.$store.state.navLv2,
                menu:[]
            }
        },
        mounted() {
            this.getMenuModules()
        },
        computed:{
            getNavLv2 () {
                return this.$store.getters.getNavLv2
            }
        },
        watch:{
            getNavLv2(value){
                this.bsactiveIndex = value
            }
        },
        methods: {
            // 获取导航显示模块
            getMenuModules(){
               this.$util.getNode('业务管理',2).then((res)=>{
                   let _navBtn = res
                   let result = {}
                   for (let i = 0;i< _navBtn.length;i++){
                       result[_navBtn[i].Name] = _navBtn[i].Url
                   }
                   this.menu = result
                })
            },
        }
    }
</script>
<style lang="less">
    .business {
        height: calc(100% - 61px) !important;
    }
    .nav-lv2 {
        height: 39px !important;
        line-height: 39px !important;
    }
    .el-menu--horizontal>.nav-lv2.is-active {
        background: #409eff !important;
        border-bottom: none !important;
    }
</style>
